import { render, staticRenderFns } from "./videoSearch.vue?vue&type=template&id=70bb0029&scoped=true&"
import script from "./videoSearch.vue?vue&type=script&lang=js&"
export * from "./videoSearch.vue?vue&type=script&lang=js&"
import style0 from "./videoSearch.vue?vue&type=style&index=0&id=70bb0029&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb0029",
  null
  
)

export default component.exports